// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* ==============================================================\n   SD-5915: Web chat carousel tag over the card\n============================================================== */\n\n/* Tag container for carousel which manages the style tag BG  */\n.satisfi_tag_container {\n\tdisplay: flex;\n}\n\n/* Tag text */\n.satisfi_tag_container .satisfi_tag_text {\n\tmargin: 0 !important;\n\tdisplay: -webkit-box;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
